/** Represents a list of routes used by the app that should not be blocked from navigation. */
// eslint-disable-next-line prettier/prettier
export const unblockableRoutes: string[] = [
    '/expired'
];
